import { InformationItemComponent } from './information-item.component';

export default angular
  .module('sfMobile.components.information-item', [
    'sfMobile.services.localization',
  ])
  .component('sfInformationItem', InformationItemComponent).name;
